(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockZahlungsmittel', {
            require: {
                form: '^form'
            },
            bindings: {
                inkassoarten: '<abzInkassoarten',
                labelInkassoart: '@abzLabelInkassoart',
                options: '<abzOptions'
            },
            templateUrl: 'bloecke/zahlungsmittel/blockZahlungsmittel.html',
            controller: BlockZahlungsmittekController,
            controllerAs: 'zahlungsmittelVm'
        });

    BlockZahlungsmittekController.$inject = [
        '$log',
        '$scope',
        '$sce',
        '$q',
        '$injector',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'AngebotUtilsService',
        'MiscUtilsService',
        'AngebotPaymentService',
        'ValidationMessageService',
        'LoadingIndicatorService',
        'FormFieldUtilsService',
        'SchluesselWerteUtilsService',
        'AdresseUtilsService',
        'AuthenticationService'
    ];
    function BlockZahlungsmittekController($log, $scope, $sce, $q, $injector, _, moment, AppConfig, AngebotModel, BasisAngebotService, AngebotUtilsService, MiscUtilsService, AngebotPaymentService, ValidationMessageService, LoadingIndicatorService, FormFieldUtilsService, SchluesselWerteUtilsService, AdresseUtilsService, AuthenticationService) {
        var vm = this,
            validationMessages = {},
            PaymentFrameService = $injector.has('PaymentFrameService') && $injector.get('PaymentFrameService');

        vm.$onInit = onInit;

        vm.setAnonymisierteDaten = setAnonymisierteDaten;
        vm.toggleInkassoart = toggleInkassoart;
        vm.initPaymentFrame = initPaymentFrame;
        vm.resetPaymentFrame = resetPaymentFrame;
        vm.onAbweichenderPraemienzahlerChanged = onAbweichenderPraemienzahlerChanged;
        vm.toggleKontoinhaber = toggleKontoinhaber;
        vm.toggleBestehendeKreditkarte = toggleBestehendeKreditkarte;
        vm.showHinweisAbweichenderPraemienzahlerNichtErlaubt = showHinweisAbweichenderPraemienzahlerNichtErlaubt;
        vm.showHinweisPaymentProviderErlaubt = showHinweisPaymentProviderErlaubt;
        vm.isBlockIbanBicVisible = isBlockIbanBicVisible;
        vm.onIbanChanged = onIbanChanged;
        vm.isZahlartTooltipErlaubt = isZahlartTooltipErlaubt;
        vm.isBlockBestehendeKreditkarteErlaubt = isBlockBestehendeKreditkarteErlaubt;
        vm.isBlockKreditkarteIframeErlaubt = isBlockKreditkarteIframeErlaubt;
        vm.checkPaymentFrame = checkPaymentFrame;
        vm.isBlockAbweichenderPraemienzahlerDisabled = isBlockAbweichenderPraemienzahlerDisabled;
        vm.isBlockAbweichenderPraemienzahlerErlaubt = isBlockAbweichenderPraemienzahlerErlaubt;
        vm.isAbweichenderPraemienzahlerAnonymisiert = isAbweichenderPraemienzahlerAnonymisiert;
        vm.isAnonymisiertHinweisSichtbar = isAnonymisiertHinweisSichtbar;
        vm.isIbanAnonymisiertVisible = isIbanAnonymisiertVisible;
        vm.isIbanAnonymisiertDisabled = isIbanAnonymisiertDisabled;
        vm.setAbwPraemienzahlerErlaubt = setAbwPraemienzahlerErlaubt;
        vm.getAdresseErrorObject = getAdresseErrorObject;
        vm.hasZahlungsmittelIcon = hasZahlungsmittelIcon;
        vm.isSepaMandatErlaubt = isSepaMandatErlaubt;

        function onInit() {
            activate();
        }

        function activate() {
            vm.options = vm.options || {};
            vm.angebotModel = AngebotModel.get();
            vm.angebotstyp = BasisAngebotService.getAngebotstyp(vm.angebotModel.angebot);
            vm.angebotAenderbar = BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANTRAG');
            vm.currentDateMinus120yearsYYYYMMDD = moment().subtract(120, 'years').format(AppConfig.API.dateFormat);
            vm.currentDateYYYYMMDD = moment().format(AppConfig.API.dateFormat);
            vm.cssClass = vm.options.cssClass || '';
            vm.labelInkassoart = vm.labelInkassoart || 'Welche Zahlungsmittel bevorzugen Sie?';

            ValidationMessageService.get('persDatenForm.paymentFrame').then(function (messages) {
                validationMessages.paymentFrame = messages;
            });

            MiscUtilsService.setDefaultValueIfEmpty(vm.angebotModel.angebot, 'zahlungsinformationen.inkassoart', _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'abbucher.wert'));
            MiscUtilsService.setDefaultValueIfEmpty(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber', _.get(BasisAngebotService.getConstant('kontoinhaber', vm.angebotModel.angebot), 'versicherungsnehmer.wert'));

            vm.placeholders = {
                paymentFrame: {
                    paymentFrame: [
                        ''  // Wert wird in checkPaymentFrame gesetzt
                    ]
                }
            };

            if (BasisAngebotService.isAngebotAnonym(vm.angebotModel.angebot) && _.get(vm.angebotModel.angebot, 'zahlungsinformationen.inkassoart') === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'abbucher.wert')) {
                BasisAngebotService.setSepaMandatErlaubt(true);
            }

            vm.angebotAnonymisiert = AngebotUtilsService.isAngebotAnonymisiert(vm.angebotModel.angebot);
            vm.anonymisierteDaten = {};
            vm.kontoType = 'IBAN';
            vm.filteredAnreden = MiscUtilsService.mergeUniq(MiscUtilsService.filterArray(SchluesselWerteUtilsService.getSchluesselwert('anreden'), ['Herr', 'Frau', 'Divers'], 'bezeichnung', true), _.get(vm.angebotModel.angebot, 'antragsteller.anrede'), 'wert');
            vm.paymentFrameOptions = {
                transactionMode: _.get(vm.angebotModel.angebot, 'zahlungsinformationen.bezahldienstleisterDaten.transactionMode')
            };

            if (
                _.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.processingResult') === PaymentFrameService.PROCESSING_RESULT_NOT_OK ||
                MiscUtilsService.isEmpty(_.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten'))
            ) {
                resetPaymentFrame();

                if (AngebotPaymentService.isKreditkarte(vm.angebotModel.angebot)) {
                    initPaymentFrame();
                }
            } else {
                vm.paymentFrameUrl = $sce.trustAsResourceUrl(_.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl'));
                vm.paymentFrameAccountNumber = _.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.accountNumber');
            }

            if (MiscUtilsService.isNotEmpty(vm.paymentFrameAccountNumber)) {
                _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.bestehendeKreditkarte', true);
            }

            setAbwPraemienzahlerErlaubt(_.get(vm.angebotModel.angebot, 'antragsteller.geburtsdatum'));
            if (MiscUtilsService.isEmpty(_.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber')) && !vm.angebotAnonymisiert) {
                BasisAngebotService.uebernehmeAngebotspartner(vm.angebotModel.angebot, 'antragsteller', 'praemienzahler', {
                    ignoreProperties: ['iban', 'bic', 'bankname', 'bankort', 'kontonummer', 'bankleitzahl', 'ibanQualitaetscode'],
                    ignorePropertiesOnlyIfNull: true
                });
            }

            BasisAngebotService.checkSepaMandatAktiv(vm.angebotModel.angebot).then(function (data) {
                BasisAngebotService.setSepaMandatErlaubt(!data);
            }).catch(function () {
            });

            $scope.$on('iplusjs:paymentFrameResult', function (event, message) {
                $log.log('iplusjs:paymentFrameResult', message);

                _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult', message);

                $scope.$applyAsync(function () {
                    LoadingIndicatorService.removeInProgress();

                    if (_.get(message, 'processingResult') === PaymentFrameService.PROCESSING_RESULT_OK) {
                        FormFieldUtilsService.setFormValidity(vm.form, 'paymentFrame', true);
                    } else {
                        FormFieldUtilsService.setFormValidity(vm.form, 'paymentFrame', false);
                        PaymentFrameService.setInProgress(false);
                    }
                });
            });

            if (PaymentFrameService) {
                PaymentFrameService.setMessageDataModelMapping({
                    'ADDRESS.STREET': 'strasse',
                    'ADDRESS.CITY': 'ort',
                    'ADDRESS.ZIP': 'postleitzahl',
                    'NAME.GIVEN': 'vorname',
                    'NAME.FAMILY': 'nachname',
                    'CONTACT.EMAIL': AngebotPaymentService.getPaymentFrameModelValue
                });
            }
        }
        function setAnonymisierteDaten(angebotspartnerPath) {
            angebotspartnerPath = angebotspartnerPath || (_.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber') === BasisAngebotService.getConstant('kontoinhaber').versicherungsnehmer.wert ? 'antragsteller' : null) || 'zahlungsinformationen.praemienzahler';

            vm.anonymisierteDaten = {
                praemienzahler: _.get(vm.angebotModel.angebotInitial, angebotspartnerPath)
            };
        }
        function toggleInkassoart(inkassoart) {
            var kontoinhaber = _.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber');

            _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentSuccess', null);

            if (inkassoart !== _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'kreditkarte.wert')) {
                FormFieldUtilsService.setFormValidity(vm.form, 'paymentFrame', true);
            }

            if (_.get(vm.angebotModel.formData, 'zahlungsinformationen.abweichenderPraemienzahler')) {
                _.set(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber', BasisAngebotService.getConstant('kontoinhaber').anderePerson.wert);
            }

            $q(function (resolve, reject) {
                if (inkassoart === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'abbucher.wert')) {
                    if (!_.get(vm.angebotModel.formData, 'zahlungsinformationen.abweichenderPraemienzahler') && (!vm.isAbwPraemienzahlerErlaubt || !kontoinhaber || kontoinhaber === BasisAngebotService.getConstant('kontoinhaber').versicherungsnehmer.wert)) {
                        _.set(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber', BasisAngebotService.getConstant('kontoinhaber').versicherungsnehmer.wert);
                        BasisAngebotService.uebernehmeAntragstellerAlsPraemienzaher(vm.angebotModel.angebot);

                        if (BasisAngebotService.isAngebotAnonym(vm.angebotModel.angebot)) {
                            BasisAngebotService.setSepaMandatErlaubt(true);
                        }
                    }
                    resolve();
                } else if (inkassoart === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'rechnung.wert')) {
                    _.set(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber', null);
                    BasisAngebotService.setSepaMandatErlaubt(false);
                    resolve();
                } else if (inkassoart === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'kreditkarte.wert')) {
                    if (_.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.processingResult') === PaymentFrameService.PROCESSING_RESULT_NOT_OK) {
                        resetPaymentFrame();
                    }

                    initPaymentFrame();
                }
            }).finally(function () {
                onIbanChanged();
            });
        }
        function initPaymentFrame() {
            _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentSuccess', null);

            LoadingIndicatorService.addInProgress();
            FormFieldUtilsService.handlePending(vm.form, 'initPayment', true);

            AngebotPaymentService.initPayment(vm.angebotModel).then(function () {
                _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentSuccess', true);
            }).catch(function (error) {
                _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentSuccess', false);
            }).finally(function () {
                LoadingIndicatorService.removeInProgress();
                FormFieldUtilsService.handlePending(vm.form, 'initPayment', false);

                vm.paymentFrameOptions = {
                    transactionMode: _.get(vm.angebotModel.angebot, 'zahlungsinformationen.bezahldienstleisterDaten.transactionMode')
                };

                vm.paymentFrameUrl = $sce.trustAsResourceUrl(_.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl'));
            });
        }
        function resetPaymentFrame() {
            _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl', null);
            _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.processingResult', null);
        }

        function onAbweichenderPraemienzahlerChanged() {
            if (_.get(vm.angebotModel, 'formData.zahlungsinformationen.abweichenderPraemienzahler') === true) {
                _.set(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber', BasisAngebotService.getConstant('kontoinhaber').anderePerson.wert);
            } else {
                _.set(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber', BasisAngebotService.getConstant('kontoinhaber').versicherungsnehmer.wert);
            }
            toggleKontoinhaber(_.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber'));

            onIbanChanged();
        }
        function toggleKontoinhaber(kontoinhaber) {
            var abwPraemienzahlerVorbelegtesAngebot = _.get(vm.angebotModel.angebotInitial, 'zahlungsinformationen.praemienzahler'),
                ignoreProperties = null;

            _.set(vm.angebotModel.angebot, 'zahlungsinformationen.sepaAktiv', null);
            if (kontoinhaber === BasisAngebotService.getConstant('kontoinhaber').anderePerson.wert && vm.hatAbwPraemienzahlerBerechtigung && !isAbweichenderPraemienzahlerAnonymisiert()) {
                BasisAngebotService.loescheAngebotspartner(vm.angebotModel.angebot, 'praemienzahler', ['iban', 'bic', 'bankname', 'bankort', 'kontonummer', 'bankleitzahl', 'ibanQualitaetscode']);
            } else if (kontoinhaber === BasisAngebotService.getConstant('kontoinhaber').anderePerson.wert && vm.isAbwPraemienzahlerVorbelegtesAngebot) {
                BasisAngebotService.uebernehmeAngebotspartner(vm.angebotModel.angebot, abwPraemienzahlerVorbelegtesAngebot, 'praemienzahler');

                _.set(vm.angebotModel, 'formData.allgemeineAntragsdaten.ibanAnonymisiert', true);
                setAnonymisierteDaten('zahlungsinformationen.praemienzahler');
            } else {
                if (isAbweichenderPraemienzahlerAnonymisiert() || (vm.isAbwPraemienzahlerVorbelegtesAngebot && !vm.hatAbwPraemienzahlerBerechtigung)) {
                    ignoreProperties = [];
                }

                BasisAngebotService.uebernehmeAntragstellerAlsPraemienzaher(vm.angebotModel.angebot, ignoreProperties);

                setAnonymisierteDaten('antragsteller');
            }
        }
        function toggleBestehendeKreditkarte(bestehendeKreditkarte) {
            _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.processingResult', !bestehendeKreditkarte ? null : PaymentFrameService.PROCESSING_RESULT_OK);

            if (!bestehendeKreditkarte) {
                _.set(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl', null);

                initPaymentFrame();
            }
        }
        function isBlockIbanBicVisible() {
            return (
                !isIbanAnonymisiertVisible() ||
                _.get(vm.angebotModel.formData, 'allgemeineAntragsdaten.ibanAnonymisiert') === false
            );
        }
        function onIbanChanged() {
            var ibanInitial = _.get(vm.angebotModel.angebotInitial, 'zahlungsinformationen.praemienzahler.iban.id'),
                iban = _.get(vm.angebotModel.angebot, 'zahlungsinformationen.praemienzahler.iban.id'),
                sepaAktivInitial = _.get(vm.angebotModel.angebotInitial, 'zahlungsinformationen.sepaAktiv', null);

            if (MiscUtilsService.isEmpty(iban)) {
                BasisAngebotService.setSepaMandatErlaubt(true);
            }

            if (MiscUtilsService.isEverythingNotEmpty(ibanInitial, iban) && _.isEqual(ibanInitial, iban)) {
                _.set(vm.angebotModel.angebot, 'zahlungsinformationen.sepaAktiv', sepaAktivInitial);
            } else {
                _.set(vm.angebotModel.angebot, 'zahlungsinformationen.sepaAktiv', null);
            }

            BasisAngebotService.checkSepaMandatAktiv(vm.angebotModel.angebot).then(function (data) {
                BasisAngebotService.setSepaMandatErlaubt(!data);
            }).catch(function () {
            });
        }
        function showHinweisAbweichenderPraemienzahlerNichtErlaubt() {
            return (
                !vm.isAbwPraemienzahlerErlaubt &&
                AppConfig.ANGEBOT.showHinweisAbweichenderPraemienzahlerNichtErlaubt &&
                _.get(vm.angebotModel.angebot, 'zahlungsinformationen.inkassoart') === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'abbucher.wert')
            );
        }
        function showHinweisPaymentProviderErlaubt() {
            return (
                AngebotPaymentService.isAlternativeBezahlmethode(vm.angebotModel.angebot)
            );
        }

        function isZahlartTooltipErlaubt(inkassoart) {
            return _.includes(['PayPal', 'SofortUeb', 'KredKarte', 'DirektUeb'], inkassoart);
        }

        function isBlockKreditkarteErlaubt() {
            var inkassoart = _.get(vm.angebotModel.angebot, 'zahlungsinformationen.inkassoart');

            return inkassoart === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'kreditkarte.wert');
        }

        function isBlockBestehendeKreditkarteErlaubt() {
            return (
                isBlockKreditkarteErlaubt() &&
                MiscUtilsService.isNotEmpty(_.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.accountNumber')) &&
                _.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult.processingResult') === PaymentFrameService.PROCESSING_RESULT_OK &&
                MiscUtilsService.isNotEmpty(vm.paymentFrameAccountNumber) // Wird nur beim activate() gesetzt
            );
        }

        function isBlockKreditkarteIframeErlaubt() {
            return (
                isBlockKreditkarteErlaubt() &&
                (
                    _.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.bestehendeKreditkarte') === false ||
                    !isBlockBestehendeKreditkarteErlaubt()
                ) &&
                MiscUtilsService.isNotEmpty(_.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameUrl'))
            );
        }

        function checkPaymentFrame() {
            var paymentFrameResult = _.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.paymentFrameResult'),
                validationText = [],
                text,
                isValid = false;

            if (_.get(vm.angebotModel.formData, 'zahlungsinformationen.bezahldienstleisterDaten.initPaymentSuccess') === false) {
                text = _.get(validationMessages.paymentFrame, 'initPaymentFailure.message');
                _.set(vm.placeholders, 'paymentFrame.paymentFrame', text);
                return false;
            }

            if (!isBlockKreditkarteIframeErlaubt() || !paymentFrameResult || !paymentFrameResult.processingResult) {
                return true;
            }

            isValid = paymentFrameResult.processingResult === PaymentFrameService.PROCESSING_RESULT_OK;

            if (!isValid) {
                _.each(paymentFrameResult.processingMissingParameters, function (val) {
                    text = _.get(validationMessages.paymentFrame, _.camelCase(val) + 'Required.message');

                    if (text) {
                        validationText.push(text);
                    }
                });

                _.each(paymentFrameResult.processingWrongParameters, function (val) {
                    text = _.get(validationMessages.paymentFrame, _.camelCase(val) + 'Invalid.message');

                    if (text) {
                        validationText.push(text);
                    }
                });

                if (_.size(validationText) > 0) {
                    _.set(vm.placeholders, 'paymentFrame.paymentFrame', validationText.join('<br>'));
                } else if (paymentFrameResult.processingReturn) {
                    _.set(vm.placeholders, 'paymentFrame.paymentFrame', [
                        paymentFrameResult.processingReturn,
                        paymentFrameResult.processingReturnCode ? (' (' + paymentFrameResult.processingReturnCode + ')') : '',
                        '.'
                    ].join(''));
                }
            }

            return isValid;
        }
        function isBlockAbweichenderPraemienzahlerDisabled() {
            return (
                !vm.angebotAenderbar ||
                (
                    vm.isAbwPraemienzahlerVorbelegtesAngebot &&
                    _.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber') === 'AnderePerson' &&
                    !vm.hatAbwPraemienzahlerBerechtigung &&
                    !AngebotUtilsService.isAngebotAnonymisiert(vm.angebotModel.angebot)
                )
            );
        }
        function isBlockAbweichenderPraemienzahlerErlaubt() {
            return (
                vm.isAbwPraemienzahlerErlaubt &&
                _.get(vm.angebotModel.angebot, 'zahlungsinformationen.inkassoart') === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'abbucher.wert') &&
                _.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber') === 'AnderePerson'
            );
        }
        function isAbweichenderPraemienzahlerAnonymisiert() {
            return (
                vm.isAbwPraemienzahlerErlaubt &&
                AngebotUtilsService.isWertAnonymisiert(_.get(vm.anonymisierteDaten, 'praemienzahler.postleitzahl'), 'PLZ') &&
                _.get(vm.angebotModel.angebotInitial, 'zahlungsinformationen.kontoinhaber') === BasisAngebotService.getConstant('kontoinhaber').anderePerson.wert
            );
        }

        function isAnonymisiertHinweisSichtbar() {
            return (
                isIbanAnonymisiertVisible() ||
                isAbweichenderPraemienzahlerAnonymisiert()
            );
        }
        function isIbanAnonymisiertVisible() {
            return (
                (
                    (
                        _.get(vm.angebotModel.angebotInitial, 'zahlungsinformationen.kontoinhaber') !== 'AnderePerson' &&
                        _.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber') !== 'AnderePerson'
                    ) || (
                        _.get(vm.angebotModel.angebotInitial, 'zahlungsinformationen.kontoinhaber') === 'AnderePerson' &&
                        _.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber') === 'AnderePerson'
                    )
                ) &&
                AngebotUtilsService.isWertAnonymisiert(_.get(vm.anonymisierteDaten, 'praemienzahler.iban'), 'IBAN')
            );
        }
        function isIbanAnonymisiertDisabled() {
            return (
                vm.isAbwPraemienzahlerVorbelegtesAngebot &&
                _.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber') === 'AnderePerson' &&
                !vm.hatAbwPraemienzahlerBerechtigung
            );
        }
        function setAbwPraemienzahlerErlaubt(geburtsdatumAntragsteller) {
            vm.isAbwPraemienzahlerVorbelegtesAngebot = (
                _.get(vm.angebotModel.angebotInitial, 'zahlungsinformationen.kontoinhaber') === BasisAngebotService.getConstant('kontoinhaber').anderePerson.wert ||
                _.get(vm.angebotModel.angebotOriginal, 'zahlungsinformationen.kontoinhaber') === BasisAngebotService.getConstant('kontoinhaber').anderePerson.wert
            );
            vm.hatAbwPraemienzahlerBerechtigung = AuthenticationService.hatBerechtigung('ANG_ABWEICHENDER_PRZ');

            if (
                vm.angebotstyp === 'VKM' &&
                (
                    (
                        MiscUtilsService.isNotEmpty(geburtsdatumAntragsteller) &&
                        moment().diff(moment(geburtsdatumAntragsteller, AppConfig.API.dateFormat), 'years', false) >= 18
                    ) || (
                        _.get(vm.angebotModel.angebot, 'antragsteller.isPartnerMinderjaehrig') === false
                    )
                ) &&
                !vm.isAbwPraemienzahlerVorbelegtesAngebot
            ) {
                vm.isAbwPraemienzahlerErlaubt = false;
            } else {
                vm.isAbwPraemienzahlerErlaubt = vm.hatAbwPraemienzahlerBerechtigung || vm.isAbwPraemienzahlerVorbelegtesAngebot;
            }

            if (vm.isAbwPraemienzahlerErlaubt) {
                vm.abweichenderPraemienzahlerAnonymisiertString = [
                    AngebotUtilsService.getAngebotspartnerNameAsString(vm.angebotModel.angebotInitial, 'praemienzahler'),
                    AngebotUtilsService.getAngebotspartnerAdresseAsString(vm.angebotModel.angebotInitial, 'praemienzahler')
                ].join('\n');
            } else {
                _.set(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber', BasisAngebotService.getConstant('kontoinhaber').versicherungsnehmer.wert);
            }
        }
        function getAdresseErrorObject(errorObjects) {
            return AdresseUtilsService.getAdresseErrorObject(errorObjects);
        }

        function hasZahlungsmittelIcon(inkassoart) {
            if (inkassoart === 'Abbucher') {
                return true;
            }
        }

        function isSepaMandatErlaubt() {
            var sepaMandatErlaubt = (
                _.get(vm.angebotModel.angebot, 'zahlungsinformationen.inkassoart') === _.get(BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot), 'abbucher.wert') &&
                _.get(vm.angebotModel.angebot, 'zahlungsinformationen.kontoinhaber') === BasisAngebotService.getConstant('kontoinhaber').versicherungsnehmer.wert &&
                BasisAngebotService.isSepaMandatErlaubt()
            );

            if (!sepaMandatErlaubt) {
                _.set(vm.angebotModel.angebot, 'zahlungsinformationen.sepaEinverstaendnis', null);
            }

            return sepaMandatErlaubt;
        }
    }
})();
